// Socket rooms that must stay joined even when a page that also joined them unmounts
// (e.g. the task-unlock dialog needs `ai_team:{id}` across every diy-doll-group page).
const pinnedRooms = new Set();

export function pinRoom(roomName) {
  pinnedRooms.add(roomName);
}

export function unpinRoom(roomName) {
  pinnedRooms.delete(roomName);
}

export function isRoomPinned(roomName) {
  return pinnedRooms.has(roomName);
}
